module.exports = __webpack_public_path__ + "img/buildings-blue.89814671.png";